import apiClient from './apiClient';

export const enrollStudent = ({ student_id, course_id, trainer_id }) => {
  return apiClient('/enrollments', {
    body: { student_id, course_id, trainer_id },
    method: 'POST',
  });
};

export const getEnrollments = (studentId) => {
  return apiClient(`/students/enrollments/${studentId}`);
};

/**
 * Marks an enrollment as paid.
 * @param {string|number} enrollmentId
 * @returns {Promise<object>} The response from the API.
 */
export const markEnrollmentPaid = (enrollmentId) => {
  return apiClient(`/enrollments/${enrollmentId}`, {
    method: 'PUT',
    body: { paid: 1 },
  });
}; 